//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Feedback } from "@/utils/notify-toaster.js";

export default {
  name: "AccountActions",
  components: {},
  props: ["token", "action"],

  data() {
    return {
      verification: true,
      pageMessageText:
        "Por favor clique em continuar para verificar o seu e-mail.",
      pageButtonText: "Verificar email",
      email: "email@email.com",
      password: "",
      passwordConfirmation: "",
      passwordMatch: false,
      isPwd1: true,
      isPwd2: true,
    };
  },
  beforeMount() {
    if (this.action == "verify") {
      this.verification = true;
    }
    if (this.action == "reset") {
      this.verification = false;
    }
  },
  beforeCreate() {
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch("destroyLocalSession");
    }
  },
  methods: {
    switchPageMode() {
      this.verification = !this.verification;
    },
    async sendAction() {
      if (!this.verification) {
        if (this.passwordMatch) {
          if (this.password.length < 6) {
            Feedback.error(
              "A passoword introduzida necessita de ter pelo menos 6 caracteres."
            );
            return;
          }
          let actionPayload = {
            password: this.password,
            passwordConfirmation: this.passwordConfirmation,
            token: this.token,
          };
          let result = await this.$store.dispatch("setPassword", actionPayload);
          if (result.status === 200) {
            Feedback.success();
            this.$router.push("/login");
          }
        } else {
          Feedback.error("As passwords não coincidem");
        }
      }
    },
    checkPassword() {
      if (this.password === this.passwordConfirmation) {
        this.passwordMatch = true;
      } else {
        this.passwordMatch = false;
      }
    },
  },
  watch: {
    verification(newValue) {
      if (newValue === false) {
        this.pageMessageText =
          "Por favor preencha os campos abaixo para alterar a sua password.";
        this.pageButtonText = "Enviar";
      } else {
        this.pageMessageText =
          "Por favor clique em continuar para verificar o seu e-mail.";
        this.pageButtonText = "Verificar email";
      }
    },
    password() {
      this.checkPassword();
    },
    passwordConfirmation() {
      this.checkPassword();
    },
  },
};
